import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Trash2, Mail, Check } from "lucide-react";
import { toast } from "sonner";

const AdminContacts = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(null);

  const load = () => {
    setLoading(true);
    api.get("/admin/contacts").then((r) => setItems(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const remove = async (id) => {
    if (!window.confirm("Delete?")) return;
    await api.delete(`/admin/contacts/${id}`);
    toast.success("Deleted"); load();
  };
  const markRead = async (id) => {
    await api.put(`/admin/contacts/${id}/read`);
    load();
  };

  return (
    <div data-testid="admin-contacts">
      <h1 className="font-display text-3xl font-black tracking-tight">Contact submissions</h1>
      <p className="text-sm text-zinc-500 mt-1">{items.length} total</p>

      <div className="mt-8 bg-white border border-zinc-200 rounded-md">
        {loading ? (
          <div className="p-10 text-center text-zinc-500 text-sm">Loading…</div>
        ) : items.length === 0 ? (
          <div className="p-10 text-center text-zinc-500 text-sm">Inbox is empty.</div>
        ) : (
          <div className="divide-y divide-zinc-100">
            {items.map((c) => (
              <div key={c.id} className="px-6 py-4">
                <div className="flex items-start justify-between gap-4">
                  <button onClick={() => setOpen(open === c.id ? null : c.id)} className="text-left flex-1">
                    <div className="font-semibold text-zinc-900 flex items-center gap-2">
                      {!c.is_read && <span className="w-2 h-2 rounded-full bg-orange-500" />}
                      {c.name} <span className="text-zinc-400 font-normal">· {c.email}</span>
                    </div>
                    <div className="text-sm text-zinc-600 mt-1 truncate max-w-2xl">{c.subject || c.message?.slice(0, 100)}</div>
                  </button>
                  <div className="flex items-center gap-2">
                    <a href={`mailto:${c.email}`} className="p-2 rounded-md hover:bg-zinc-100 text-zinc-600"><Mail size={16} /></a>
                    {!c.is_read && (
                      <button onClick={() => markRead(c.id)} title="Mark read" className="p-2 rounded-md hover:bg-green-50 text-green-600"><Check size={16} /></button>
                    )}
                    <button onClick={() => remove(c.id)} className="p-2 rounded-md hover:bg-red-50 text-red-600"><Trash2 size={16} /></button>
                  </div>
                </div>
                {open === c.id && (
                  <div className="mt-4 bg-zinc-50 border border-zinc-100 rounded-md p-4 text-sm text-zinc-700 space-y-2">
                    <div><b>Phone:</b> {c.phone || "—"}</div>
                    <div><b>Company:</b> {c.company || "—"}</div>
                    <div><b>Product interest:</b> {c.product_interest || "—"}</div>
                    <div><b>Subject:</b> {c.subject || "—"}</div>
                    <div className="whitespace-pre-wrap pt-2 border-t border-zinc-200"><b>Message:</b><br />{c.message}</div>
                    <div className="text-xs text-zinc-400 pt-2">{new Date(c.created_at).toLocaleString()}</div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminContacts;
